import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AbilityEffect,
  ConsumedResource,
  ItemLimitation,
  SpellInfusionExtraEffectsFeature,
  SpellLimitation,
} from "@dndModels";

import ItemLimitInput from "@dndComponents/limitations/ItemLimitInput";
import SpellLimitInput from "@dndComponents/limitations/SpellLimitInput";
import EffectsInput from "@dndComponents/feature/EffectsInput";
import ConsumedResourceInput from "@dndComponents/feature/ConsumedResourceInput";
import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  obj: SpellInfusionExtraEffectsFeature;
  onChange: (changed: SpellInfusionExtraEffectsFeature) => void; 
  disabled: boolean;
}

export default function SpellInfusionExtraEffectsFeatureInput({
  obj,
  onChange,
  disabled,
}: Props) {
  const [ping, setPing] = useState(false);
  const [reloading, setReloading] = useState(false);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox
          name="Type"
          value={obj.type}
          options={["On Spell","On Attack","Reaction"]}
          disabled={disabled}
          onChange={(changed: "On Spell" | "On Attack" | "Reaction") => {
            const new_obj = obj;
            new_obj.type = changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <ItemLimitInput
          obj={obj.item_limit}
          disabled={disabled}
          // change_time={change_time}
          onChange={(changed: ItemLimitation) => {
            obj.item_limit.copy(changed);
            onChange(obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <SpellLimitInput
          obj={obj.spell_limit}
          disabled={disabled}
          // change_time={change_time}
          onChange={(changed: SpellLimitation) => {
            obj.spell_limit.copy(changed);
            onChange(obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <EffectsInput
          effects={obj.effects}
          disabled={disabled}
          for_obj={obj}
          onChange={(changed: AbilityEffect[]) => {
            const new_obj = obj;
            obj.effects = changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <ConsumedResourceInput 
          obj={obj.consumed_resource} 
          disabled={false}
          onChange={(changed: ConsumedResource) => {
            const new_obj = obj;
            new_obj.consumed_resource = changed;
            onChange(new_obj);
            setReloading(true);
          }}
        />
      </Grid>
    </Grid>
  );
}

